// Generated from docs/typologies.txt — do not hand-edit.
export const ACTIVITY_DETAILS = [
  {
    "name": "Communications & Narrative Change",
    "description": "Shaping public discourse, perception, and understanding through storytelling, media, framing, and cultural expression.",
    "subs": [
      {
        "name": "Framework & Narrative Building",
        "description": "Crafting overarching frames, storylines, or discourses to shape understanding and public debate.",
        "examples": [
          "Framing issues",
          "Shaping public awareness",
          "Influencing public discourse"
        ]
      },
      {
        "name": "Arts & Cultural Action",
        "description": "Using creative media, artistic expression, and cultural practices to inspire, engage, and mobilize people.",
        "examples": [
          "Storytelling",
          "Experiential engagement",
          "Public installations",
          "Film and theatre"
        ]
      },
      {
        "name": "Strategic Communications",
        "description": "Planning and executing coordinated communication efforts to influence public opinion, shift narratives, and advance social or political goals.",
        "examples": [
          "Messaging strategies",
          "Coordinating communications across coalitions",
          "Mapping narrative ecosystems to identify influencers and opponents"
        ]
      },
      {
        "name": "Media & Publications",
        "description": "Publishing, distributing, or amplifying information and stories through traditional and digital channels.",
        "examples": [
          "Communicating scientific data",
          "Magazine publishing",
          "Dissemination campaigns",
          "Distribution activities"
        ]
      },
      {
        "name": "Futures Thinking & Visioning",
        "description": "Exploring possible, probable, or preferred futures to inform strategies and inspire action.",
        "examples": [
          "Developing scenarios",
          "Conducting foresight exercises",
          "Crafting shared long-term visions",
          "Exploring preferred futures"
        ]
      }
    ]
  },
  {
    "name": "Research & Knowledge Generation",
    "description": "Creating new insights, evidence, and ideas through participatory, academic, and foresight methods to inform action & policy.",
    "subs": [
      {
        "name": "Grassroots Research",
        "description": "Collecting knowledge directly from communities through participatory or citizen-led methods.",
        "examples": [
          "Community-driven research",
          "Participatory and experiential approaches",
          "Citizen-led data collection"
        ]
      },
      {
        "name": "Institutional Research",
        "description": "Conducting formal research by experts or organisations to provide evidence or analysis.",
        "examples": [
          "Structured academic research",
          "Think tank studies",
          "Expert-led applied research",
          "Formal institutional research"
        ]
      },
      {
        "name": "Monitoring Progress",
        "description": "Tracking, measuring, or evaluating changes over time to assess impact or inform decisions.",
        "examples": [
          "Evaluation and learning practices",
          "Developing indicators or metrics",
          "Impact assessments",
          "Monitoring policy outcomes"
        ]
      }
    ]
  },
  {
    "name": "Capacity Building & Education",
    "description": "Equipping individuals and institutions with the skills, tools, and knowledge needed to lead and sustain transformative change.",
    "subs": [
      {
        "name": "Grassroots Education & Training",
        "description": "Building skills and leadership among community members, frontline organizers, or marginalized groups through accessible, community-rooted formats.",
        "examples": [
          "Workshops",
          "Peer-to-peer learning",
          "Political education",
          "Community organizing schools",
          "Mentorship for local leaders"
        ]
      },
      {
        "name": "Professional Education & Development",
        "description": "Providing formal or ongoing development for professionals, practitioners, or institutional leaders.",
        "examples": [
          "Structured trainings",
          "Executive education",
          "Certification programs",
          "In-house capacity building",
          "Sectoral fellowships",
          "Academic degree programs"
        ]
      },
      {
        "name": "Changing Curricula",
        "description": "Transforming what and how key subjects like economics are taught by integrating diverse theories, pluralist perspectives, and real-world challenges.",
        "examples": [
          "Creating alternative university courses",
          "Transforming economics curricula",
          "Embedding pluralist and systems thinking"
        ]
      },
      {
        "name": "Technical Services",
        "description": "Designing practical resources, tools, or technical assistance to support effective action.",
        "examples": [
          "Mission-aligned advisory",
          "Tailored support with specialized expertise",
          "Practical toolkits for practitioners"
        ]
      }
    ]
  },
  {
    "name": "Activism & Advocacy",
    "description": "Driving social and policy change by raising public pressure, influencing decision-makers, and holding power to account.",
    "subs": [
      {
        "name": "Campaigning & Public Engagement",
        "description": "Mobilising people and resources to publicly demand change through action.",
        "examples": [
          "Petitions and protests",
          "Awareness campaigns",
          "Direct action",
          "Media work",
          "Community organising",
          "Political campaigning"
        ]
      },
      {
        "name": "Policy Advocacy & Lobbying",
        "description": "Shaping policy debates by developing proposals, building broad-based support, and engaging policymakers.",
        "examples": [
          "Policy briefs",
          "Engaging with policymakers",
          "Providing expert input",
          "Shaping legislation"
        ]
      },
      {
        "name": "Legal Action & Litigation",
        "description": "Using courts or legal systems strategically to advance rights, enforce laws, or challenge injustices.",
        "examples": [
          "Strategic use of courts",
          "Judicial advocacy",
          "Public interest litigation"
        ]
      }
    ]
  },
  {
    "name": "Demonstration",
    "description": "Testing innovative solutions in real-world contexts to validate feasibility, learn, and refine before wider adoption.",
    "subs": [
      {
        "name": "Ideation & Concepting",
        "description": "Developing new concepts, solutions, or innovations to address systemic challenges.",
        "examples": [
          "Hackathons",
          "Innovation labs",
          "Creative workshops",
          "Crowdsourcing solutions"
        ]
      },
      {
        "name": "Prototyping New Services",
        "description": "Designing and testing early versions of services or products to explore feasibility and gather user feedback.",
        "examples": [
          "Minimum viable services",
          "Early-stage community-based offerings"
        ]
      },
      {
        "name": "Enterprise & Asset Development",
        "description": "Creating or growing enterprises or assets aligned with deep social and ecological principles.",
        "examples": [
          "Developing nonprofit or not-for-profit organisations",
          "Building community-owned utilities",
          "Managing shared assets or properties"
        ]
      },
      {
        "name": "Demonstrator Sites",
        "description": "Establishing physical or virtual spaces where innovative models can be experienced, refined, and showcased in action.",
        "examples": [
          "Urban living labs",
          "Regenerative farm pilots",
          "Circular economy hubs"
        ]
      }
    ]
  },
  {
    "name": "Scaling & Diffusing",
    "description": "Expanding proven solutions to reach broader communities, sectors, or markets, and sharing them for replication or adaptation.",
    "subs": [
      {
        "name": "Model Replication & Adaptation",
        "description": "Supporting the direct copying or tailoring of successful approaches so they can be implemented in new contexts.",
        "examples": [
          "Helping communities set up similar food co-ops",
          "Adapting a proven community land trust model to a new city"
        ]
      },
      {
        "name": "Knowledge Dissemination & Toolkit Development",
        "description": "Sharing materials, frameworks, and evidence that make it easier for others to learn from and apply successful innovations.",
        "examples": [
          "Publishing practical guides",
          "Open-source manuals",
          "Case studies of working models"
        ]
      },
      {
        "name": "Scaling Through Partnerships & Institutional Adoption",
        "description": "Expanding proven solutions by building partnerships and embedding models within public institutions, policies, or established organisations to ensure broad and sustained adoption.",
        "examples": [
          "Collaborating with local governments to embed community land trust models",
          "Partnering with rural networks to spread regenerative farming practices",
          "Securing policy changes through mainstream participatory budgeting"
        ]
      }
    ]
  },
  {
    "name": "Funding & Resource Mobilisation",
    "description": "Securing and directing financial and non-financial resources to support transformative initiatives and shared goals.",
    "subs": [
      {
        "name": "Grantmaking & Philanthropic Funding",
        "description": "Providing financial support through grants to advance mission-aligned work.",
        "examples": [
          "Issuing calls for proposals",
          "Managing grant portfolios",
          "Participatory grantmaking"
        ]
      },
      {
        "name": "Regranting & Pooling Funds",
        "description": "Aggregating and redistributing resources to multiple organisations or initiatives.",
        "examples": [
          "Creating collective investment vehicles",
          "Movement funds",
          "Ecosystem grant pools"
        ]
      },
      {
        "name": "Impact Investing",
        "description": "Deploying patient capital to generate measurable social and environmental impact alongside financial returns.",
        "examples": [
          "Catalytic blended-finance funds",
          "Mission-aligned equity stakes",
          "Social-impact bonds",
          "Revenue-based financing for climate-tech ventures"
        ]
      },
      {
        "name": "Mobilising Public Funding & Subsidies",
        "description": "Securing government or institutional funding to support projects or organisations.",
        "examples": [
          "EU Horizon grants",
          "National green-industrial subsidies",
          "Municipal innovation vouchers",
          "Guaranteed-loan programmes"
        ]
      },
      {
        "name": "Non-financial Resource Sharing",
        "description": "Exchanging or pooling in-kind resources, knowledge, or services among partners or networks.",
        "examples": [
          "Movement generosity",
          "Time banks",
          "In-kind resource pooling among ecosystem actors"
        ]
      }
    ]
  },
  {
    "name": "Movement Building & Organising",
    "description": "Strengthening collective power by developing leadership, aligning actors, and coordinating efforts for systemic change.",
    "subs": [
      {
        "name": "Grassroots Organising & Power Building",
        "description": "Strengthening the capacity of communities to identify issues, build collective power, and take action to change their conditions from the bottom up.",
        "examples": [
          "Base-building in communities",
          "Leadership development",
          "Training local organisers",
          "Mobilising collective action"
        ]
      },
      {
        "name": "Strategy Development",
        "description": "Creating clear, shared plans to guide collective action toward long-term goals.",
        "examples": [
          "Designing theory of change frameworks",
          "Setting long-term priorities",
          "Aligning stakeholders around shared pathways",
          "Facilitating strategic planning processes"
        ]
      },
      {
        "name": "Coalition Building",
        "description": "Forming a structured alliance of diverse actors to coordinate efforts, amplify influence, and advocate around a shared set of objectives.",
        "examples": [
          "Bringing together NGOs, labour unions, and advocacy groups",
          "Coordinating towards shared political goals",
          "Sharing resources and advocacy under a unified banner"
        ]
      },
      {
        "name": "Orchestration",
        "description": "Aligning diverse actors to bridge silos, coordinate actions, and maintain coherence in complex, long-term collaborations.",
        "examples": [
          "Facilitating a cross-sector task force on regenerative agriculture",
          "Aligning roles across government, farmers, researchers, and funders",
          "Coordinating meetings and monitoring progress",
          "Adapting shared action plans over time"
        ]
      }
    ]
  }
];

export const THEME_DETAILS = [
  {
    "name": "Public Finance & Financial System Reform",
    "description": "Transforming the rules, institutions, and governance of the public and private financial system to promote stability, equity, and alignment with long-term public and ecological goals.",
    "subs": [
      {
        "name": "Global Financial Architecture Reform",
        "description": "Transforming international financial institutions and rules to promote equity and sustainability.",
        "examples": [
          "Creation of international currency clearing union",
          "Sovereign debt workout frameworks",
          "Ending austerity-based conditionalities",
          "Growth-independent money creation",
          "Global capital controls"
        ]
      },
      {
        "name": "Monetary System Reform",
        "description": "Reforming monetary systems to support ecological integrity and social justice by steering capital toward regenerative activities and away from destructive ones.",
        "examples": [
          "Joint climate & nature investment strategies",
          "Public banks directing credit to regenerative sectors",
          "Central banks restricting finance to destructive sectors",
          "Aligned monetary mandates",
          "Green and nature-linked sovereign bonds"
        ]
      },
      {
        "name": "Public Investment, Wealth & Asset Stewardship",
        "description": "Mobilising and governing public resources and collective assets to promote equity, collective wellbeing, ecological regeneration, and long-term value preservation.",
        "examples": [
          "Sovereign wealth funds for public benefit",
          "Green public banks",
          "Resilient infrastructure development",
          "Publicly-owned enterprises",
          "Social dividend systems"
        ]
      },
      {
        "name": "Fiscal Policy & Taxation",
        "description": "Designing fair tax and spending systems that raise public revenues equitably and redistribute them to reduce inequality, fund collective goods, and correct harmful economic externalities.",
        "examples": [
          "Progressive income and wealth taxes",
          "International tax coordination",
          "Closing loopholes",
          "Carbon levies",
          "Land value taxes",
          "Digital infrastructure fees",
          "Redirecting revenues to fund public goods"
        ]
      },
      {
        "name": "Financial Market Governance",
        "description": "Establishing rules and oversight to ensure financial markets serve the common good and avoid systemic risks.",
        "examples": [
          "Financial transaction taxes",
          "ESG standard reform",
          "Capital flow controls",
          "Integration of climate considerations"
        ]
      }
    ]
  },
  {
    "name": "Alternative Finance Systems",
    "description": "Building new financial models and institutions that operate outside the logic of mainstream finance to prioritise sustainability, democratic control, and the common good.",
    "subs": [
      {
        "name": "Innovative Financial Instruments",
        "description": "Structured financial tools designed to channel investment into environmental and social goals.",
        "examples": [
          "Ecosystem services valorization",
          "Impact bonds"
        ]
      },
      {
        "name": "Community Finance Institutions",
        "description": "Locally rooted or mission-driven financial institutions offering credit, banking, and lending aligned with community wellbeing and equity.",
        "examples": [
          "Cooperative banks",
          "Credit unions",
          "Ethical lending schemes",
          "Community development finance institutions"
        ]
      },
      {
        "name": "Transformative Capital",
        "description": "Ecosystems of capital flows designed to shift the logic of finance toward long-term impact and justice.",
        "examples": [
          "Systemic investment",
          "Re-imagining philanthropy",
          "Blended finance",
          "Patient capital",
          "Mission-aligned investment vehicles"
        ]
      },
      {
        "name": "Complementary Currency Systems",
        "description": "Non-mainstream exchange systems aimed at building local resilience and diversifying economic value exchange.",
        "examples": [
          "New payment systems",
          "Digital public money",
          "Time banks",
          "Mutual credit systems",
          "Local currencies"
        ]
      },
      {
        "name": "Alternative Economic Valuation Approaches",
        "description": "Measurement approaches that assess societal progress across ecological integrity, equity, and wellbeing, complementing or replacing GDP.",
        "examples": [
          "Wellbeing indexes",
          "Social value frameworks",
          "Multidimensional poverty metrics",
          "Footprint and natural-capital accounting"
        ]
      }
    ]
  },
  {
    "name": "Market Governance & Oversight",
    "description": "Redesigning rules and oversight of markets and industries to ensure democratic accountability, public interest, and ecological integrity.",
    "subs": [
      {
        "name": "Consumer Rights & Protections",
        "description": "Ensuring individuals are protected in markets through safety standards, transparency, and equitable access.",
        "examples": [
          "Right-to-repair laws",
          "Fair pricing regulations",
          "Product labeling requirements",
          "Anti-predatory lending laws"
        ]
      },
      {
        "name": "Industrial Policy & Sectoral Governance",
        "description": "Using policy to steer specific sectors toward public interest outcomes, innovation, and ecological transformation.",
        "examples": [
          "Green industrial strategies",
          "R&D funding",
          "Clean tech subsidies",
          "Procurement mandates"
        ]
      },
      {
        "name": "Corporate Power Dynamics",
        "description": "Limiting corporate concentration and influence through anti-monopoly action and democratic oversight.",
        "examples": [
          "Breaking up dominant platforms",
          "Lobbying transparency rules",
          "Platform accountability regulations",
          "Supply chain audits"
        ]
      },
      {
        "name": "Equitable Trade Systems",
        "description": "Restructuring trade systems to center justice, sustainability, and local resilience in global economic relationships.",
        "examples": [
          "Fair trade agreements",
          "Local procurement rules",
          "Carbon border adjustments",
          "Just transition clauses in trade deals"
        ]
      },
      {
        "name": "Institutional Investment Governance",
        "description": "Reforming mandates, incentives, and governance of large financial institutions — such as pension funds and insurers — to align capital allocation with long-term public, social, and ecological goals.",
        "examples": [
          "Redirecting pension fund investments",
          "Reforming fiduciary duties"
        ]
      },
      {
        "name": "Price & Market Regulation",
        "description": "Using rules, subsidies, and pricing mechanisms to make essential goods and services affordable, prevent profiteering, and reflect true social and ecological costs in markets.",
        "examples": [
          "Setting fair prices for essentials",
          "Targeted subsidies and social tariffs",
          "Embedding ecological costs through polluter-pays rules",
          "Portable benefits and price stabilisation"
        ]
      }
    ]
  },
  {
    "name": "Socio-Economic Security & Justice",
    "description": "Ensuring everyone has the security and resources to meet their basic needs, live with dignity, and participate fully in society.",
    "subs": [
      {
        "name": "Care Systems",
        "description": "Promoting and creating systems that prioritise holistic physical, mental, and social wellbeing, with accessible and equitable care.",
        "examples": [
          "Centering care in socioeconomic systems",
          "New models of social security",
          "Childcare, elderly care, disability justice",
          "Supporting unpaid care",
          "Preventative care"
        ]
      },
      {
        "name": "Universal Income Systems",
        "description": "Guaranteed, unconditional cash payments provided regularly to all individuals, ensuring a baseline of financial security.",
        "examples": [
          "Unconditional cash transfers",
          "Negative income tax",
          "Social dividends",
          "Income-based welfare programs"
        ]
      },
      {
        "name": "Work & Labour Futures",
        "description": "Adapting labour systems and job structures to respond to technological change, automation, and evolving worker needs.",
        "examples": [
          "Shortened workweek",
          "Job guarantees",
          "AI displacement strategies"
        ]
      },
      {
        "name": "Universal Basic Services",
        "description": "Providing guaranteed access to essential public goods and services as a right for all, regardless of income.",
        "examples": [
          "Decommodification of public goods",
          "Publicly funded housing",
          "Universal healthcare",
          "Free public transit",
          "Access to education"
        ]
      },
      {
        "name": "Decolonial Futures",
        "description": "Challenging systems of oppression and extractivism while supporting transitions that elevate Indigenous, racialized, feminist, and historically marginalized perspectives",
        "examples": [
          "Challenging extractive and patriarchal systems",
          "Land rematriation"
        ]
      }
    ]
  },
  {
    "name": "Democratic Participation & Economic Democracy",
    "description": "Expanding people’s collective agency in shaping decisions, policies, and institutions through inclusive governance, organising, and participatory democratic infrastructure.",
    "subs": [
      {
        "name": "Worker Rights & Infrastructure",
        "description": "Ensuring democratic representation, fair wages, and safe conditions for workers through mechanisms like unions, job guarantees, and collective bargaining.",
        "examples": [
          "Collective bargaining structures",
          "Union modernization",
          "Job guarantees",
          "Worker councils",
          "Labour protections"
        ]
      },
      {
        "name": "Participatory Organising Models",
        "description": "Building systems and tools that enable inclusive, deliberative, and empowered citizen participation in economic governance and public decision-making.",
        "examples": [
          "Citizens’ assemblies",
          "Tenant Unions",
          "Digital democracy tools",
          "Community councils",
          "Community planning boards"
        ]
      },
      {
        "name": "Digital Social Utilities",
        "description": "Publicly or cooperatively owned digital infrastructure designed to serve collective needs, such as open-source platforms and community-controlled technologies.",
        "examples": [
          "Open-source platforms for public use",
          "Federated social networks",
          "Municipal broadband",
          "Data and platform cooperatives"
        ]
      },
      {
        "name": "Commons-based Resource & Consumption",
        "description": "Collectively managing and consuming material and ecological resources through equitable, regenerative, and non-extractive systems that prioritise shared access and community control.",
        "examples": [
          "Sharing economy platforms",
          "Community-led reuse and repair networks",
          "Open-source knowledge production",
          "Local food cooperatives"
        ]
      },
      {
        "name": "Alternative Ownership & Governance Models",
        "description": "Ownership systems that distribute power, decision-making, and benefits across stakeholders to better align with social and ecological goals",
        "examples": [
          "Cooperatives",
          "Steward-owned businesses",
          "Land trusts",
          "Platform cooperatives",
          "Governance by trusteeship",
          "Legally embedded mission locks"
        ]
      },
      {
        "name": "Rights of Nature & Future Generations",
        "description": "Recognising and protecting the intrinsic rights of nature and the interests of people not yet born, embedding ecological integrity and intergenerational justice in present-day governance, law, and decision-making.",
        "examples": [
          "Promoting intergenerational justice frameworks",
          "Embedding long-term thinking in law and policy",
          "Recognising legal rights of ecosystems",
          "Creating guardianship models"
        ]
      }
    ]
  },
  {
    "name": "Alternative Economic Models",
    "description": "Exploring economic paradigms that reorient economies toward ecological balance, collective wellbeing, and justice — challenging dominant assumptions of growth, competition, and extractivism.",
    "subs": [
      {
        "name": "Ecological Economics & Science-Based Frameworks",
        "description": "Economic and governance approaches that integrate planetary boundaries and regional ecological limits.",
        "examples": [
          "Planetary boundaries and ecological ceilings",
          "Doughnut Economics",
          "Carbon budgeting and ecological fiscal rules",
          "Macroeconomic modeling that integrate climate"
        ]
      },
      {
        "name": "Sufficiency & Post-Growth Paradigms",
        "description": "Paradigms that prioritise wellbeing and equity within limits, rejecting endless economic expansion and focusing on enoughness, redistribution, and resilience.",
        "examples": [
          "Downscaling of material throughput",
          "Sufficiency-based policy",
          "Post-growth planning",
          "Limits to resource extraction",
          "Holistic circular economy approaches"
        ]
      },
      {
        "name": "Pluriversal & Indigenous Economic Paradigms",
        "description": "Frameworks grounded in relational ontologies and Indigenous knowledge, advancing wellbeing and responsibility across people and nature.",
        "examples": [
          "Buen Vivir",
          "Ubuntu economics",
          "Decolonial critiques"
        ]
      },
      {
        "name": "Social Solidarity Economics",
        "description": "Economies organised around collective ownership, democratic control, and meeting shared needs — challenging profit-maximisation and private capital concentration.",
        "examples": [
          "Social Solidarity Economy (SSE)",
          "Commons-based economies",
          "Cooperative economics",
          "Participatory planning",
          "Foundational Economy"
        ]
      }
    ]
  },
  {
    "name": "Place-Based Resilience",
    "description": "Place-based strategies that strengthen ecological integrity, climate adaptability, and community self-determination — ensuring territories are restored, resilient, and governed for long-term sustainability and justice.",
    "subs": [
      {
        "name": "Ecosystem Governance & Regeneration",
        "description": "Reviving and sustaining ecosystems through models that reconnect ecological health with community stewardship, equitable governance, and regenerative economic value.",
        "examples": [
          "Rewilding initiatives",
          "Community-based conservation",
          "Air-quality management",
          "Ecosystem restoration alliances",
          "Biodiversity trusts"
        ]
      },
      {
        "name": "Community-led Transitions",
        "description": "Local, citizen-driven initiatives at the neighbourhood or town level that reimagine how communities organise resources, culture, and decision-making.",
        "examples": [
          "Neighbourhood food initiatives",
          "Ecovillages and intentional communities",
          "Local transition groups",
          "Eco-neighbourhood pilots"
        ]
      },
      {
        "name": "Regional Transitions",
        "description": "Designing locally tailored strategies that strengthen communities’ ability to adapt and transform in response to systemic challenges.",
        "examples": [
          "Bioregional transition strategies",
          "Community wealth-building",
          "Climate-adaptive infrastructure plans",
          "Localised circular economy hubs"
        ]
      },
      {
        "name": "Climate Adaptation & Resilience",
        "description": "Building adaptive capacity through socially just and community-led systems that redistribute risk, embed local knowledge, and rewire economic and governance structures to support long-term climate resilience.",
        "examples": [
          "Community-owned flood infrastructure",
          "Climate resilience hubs",
          "Adaptive commons governance",
          "Participatory climate budgeting",
          "Localised insurance and risk-pooling"
        ]
      }
    ]
  },
  {
    "name": "Sectoral System Transformation",
    "description": "Transformative changes across the essential sectors that underpin daily life to ensure that basic societal functions are delivered in ways that are sustainable, equitable, and resilient.",
    "subs": [
      {
        "name": "Food & Land Use",
        "description": "Shifting agricultural and land systems toward sustainable, equitable, and regenerative practices that support ecological health and food justice.",
        "examples": [
          "Regenerative agriculture",
          "Agroecology",
          "Food sovereignty movements",
          "Land back and land commons initiatives"
        ]
      },
      {
        "name": "Energy",
        "description": "Transitioning from fossil fuels to renewable, decentralized, and just energy systems that empower communities.",
        "examples": [
          "Community energy cooperatives",
          "Fossil fuel phase-out policies",
          "Renewable energy access",
          "Energy democracy initiatives"
        ]
      },
      {
        "name": "Water",
        "description": "Transforming water management to ensure equitable access, ecological integrity, and climate resilience.",
        "examples": [
          "Watershed-based management",
          "Water governance reform",
          "Climate-adaptive infrastructure"
        ]
      },
      {
        "name": "Housing & the Built Environment",
        "description": "Redesigning how we build, inhabit, and own space to enable inclusive, affordable, and sustainable living environments.",
        "examples": [
          "Social housing cooperatives",
          "Retrofitting and energy efficiency programs",
          "Climate-adaptive urban design",
          "Land value capture"
        ]
      },
      {
        "name": "Mobility & Transportation",
        "description": "Redesigning mobility systems to prioritize low-carbon, accessible, and equitable transportation options.",
        "examples": [
          "Public transit expansion",
          "Walkable and bikeable cities",
          "Electrified logistics",
          "Inclusive transport access"
        ]
      },
      {
        "name": "Information Technology",
        "description": "Reclaiming the governance, ownership, and economic value of digital systems.",
        "examples": [
          "Challenging platform monopolies",
          "Regulating Artificial Intelligence efforts",
          "Community-owned data commons",
          "Digital labour platforms",
          "Privacy-protecting digital infrastructure"
        ]
      }
    ]
  }
];
